module.exports = __webpack_public_path__ + "img/196.b2be897d.jpg";